export enum CustomerEventType {
	order_placed = 'order_placed',
	order_requested = 'order_requested',
	payment_request = 'payment_request',
	waiter_requested = 'waiter_requested',
	online_payment = 'online_payment',
}
